import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { useForm } from 'react-hook-form';
import ClosureSuccess from 'pages/Closures/ClosureSuccess';
import { ClosureForm } from 'types';
import { FormStepComponentProps } from '../MultiStepForm';
import { ClosureContext } from '../../../pages/Closures/ClosureClose';

const useStyles = makeStyles({
  form: {
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
  },
});

const Step4: React.FC<FormStepComponentProps<ClosureForm, ClosureContext>> = ({ formName, onSubmit }) => {
  const classes = useStyles();

  const { handleSubmit } = useForm<ClosureForm>({
    mode: 'onBlur',
  });

  return (
    <form id={formName} onSubmit={handleSubmit(onSubmit)} className={classes.form}>
      <ClosureSuccess isPreview={false} />
    </form>
  );
};

export default Step4;
